import {CurrencyConfiguration} from "@next/utils"
import {ColourChipsPerRow, Imagery, SaleSashConfig, SavingsSashConfig} from "../ProductSummary"

export const FeatureSettingKeys = {
    enableFavourites: "plp.favourites.is-enabled",
    globalPriceFormattingConfig: "global.price-formatting.config",
    useProductAggregator: "plp.use-product-aggregator.is-enabled",
    imagesConfig: "plp.images.config",
    productSingleLineTitle: "plp.product-single-line-title.is-enabled",
    enableFurtherReductionsSash: "plp.further-reductions-sash.is-enabled",
    savingsSashConfig: "plp.savings-sash.config",
    enableQuickAddToBag: "plp.quick-add-to-bag.is-enabled",
    enableBrandDisplay: "plp.product-brand-display.is-enabled",
    saleSashConfig: "plp.sale-sash.config",
    imageCdnDomainUrl: "global.image-cdn.domain-url",
    template: "plp.product-template.name",
    themeName: "global.theme.name",
    colourChipsPerRow: "plp.colour-chips-per-row.config",
    enableReviewStars: "plp.product-review-stars.is-enabled",
    displayFitIcons: "plp.display-fit-icons.is-enabled",
} as const

export type FeatureSettingKey = (typeof FeatureSettingKeys)[keyof typeof FeatureSettingKeys]

export type ValueObject<T> = {
    Value: T
}

export interface FeatureSettings {
    [FeatureSettingKeys.enableFavourites]: boolean
    [FeatureSettingKeys.globalPriceFormattingConfig]: CurrencyConfiguration
    [FeatureSettingKeys.useProductAggregator]: boolean
    [FeatureSettingKeys.imagesConfig]: Imagery
    [FeatureSettingKeys.productSingleLineTitle]: boolean
    [FeatureSettingKeys.enableFurtherReductionsSash]: boolean
    [FeatureSettingKeys.savingsSashConfig]: SavingsSashConfig
    [FeatureSettingKeys.enableQuickAddToBag]: boolean
    [FeatureSettingKeys.enableBrandDisplay]: boolean
    [FeatureSettingKeys.saleSashConfig]: SaleSashConfig
    [FeatureSettingKeys.imageCdnDomainUrl]: string
    [FeatureSettingKeys.template]: string
    [FeatureSettingKeys.themeName]: string
    [FeatureSettingKeys.colourChipsPerRow]: ColourChipsPerRow
    [FeatureSettingKeys.enableReviewStars]: boolean
    [FeatureSettingKeys.displayFitIcons]: boolean
}

export const defaultFeatFlagValues: FeatureSettings = {
    [FeatureSettingKeys.enableFavourites]: true,
    [FeatureSettingKeys.globalPriceFormattingConfig]: {} as CurrencyConfiguration,
    [FeatureSettingKeys.useProductAggregator]: false,
    [FeatureSettingKeys.imagesConfig]: {
        folder: "SearchAlt",
        akamaiImageManagerParams: {lg: "", sm: ""},
        dimension: "678x904",
        ratio: "3x4",
        usePDPImage: false,
    },
    [FeatureSettingKeys.productSingleLineTitle]: true,
    [FeatureSettingKeys.enableFurtherReductionsSash]: false,
    [FeatureSettingKeys.savingsSashConfig]: {
        sale: 0,
        clearance: 0,
    },
    [FeatureSettingKeys.enableQuickAddToBag]: false,
    [FeatureSettingKeys.enableBrandDisplay]: false,
    [FeatureSettingKeys.saleSashConfig]: {
        type: "Sale",
        position: "TL",
    },
    [FeatureSettingKeys.imageCdnDomainUrl]: "https://cdn.platform.next",
    [FeatureSettingKeys.template]: "standard",
    [FeatureSettingKeys.themeName]: "",
    [FeatureSettingKeys.colourChipsPerRow]: {
        lg: 7,
        xl: 8,
    },
    [FeatureSettingKeys.enableReviewStars]: false,
    [FeatureSettingKeys.displayFitIcons]: true,
}
